<template>
  <div class="container-static">
    <div class="form-container">
      <SiteLogo/>
      <div v-if="!loader">
        <RegistrationByEmailForm
          :regRulesAndTerms="regRulesAndTerms"
        />
      </div>
      <div v-else class="group-data-loader">
        <spinner/>
      </div>
      <div class="link-tabs">
        <button class="link main-page-link" @click="gotoMainPage">продолжить без регистрации</button>
        <!-- <a class="link main-page-link" href="/">вернуться на главную</a> -->
      </div>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import RegistrationByEmailForm from '@/components/IdentityForms/RegistrationByEmailForm.vue';
import UserRegNotice from '@/components/IdentityForms/UserRegNotice.vue';

export default {
  components: {
    RegistrationByEmailForm,
    UserRegNotice
  },
  data: function () {
    return {
      loader: true,
      // userRegRulesAndTermsLoader: true,
      regRulesAndTerms: null
    }
  },
  computed: {
    title() { return document.title; }
  },
  methods: {
    gotoMainPage() {
      this.$store.dispatch('setGuest', true);
      window.location.href = '/';
    },
    loadUserRegRulesAndTerms() {
      this.loader = true;
      this.$http.get(`${this.$host.IdentityServiceApi}/UserRegRulesAndTerms`)
      .then((response) => {
        this.regRulesAndTerms = response.body;
        this.loader = false;
      })
      .catch(() => {
        this.regRulesAndTerms = null;
        this.loader = false;
      })
    }
  },
  created() {
    this.$store.dispatch('setGuest', false);
    this.loadUserRegRulesAndTerms();
  }
}
</script>

<style scoped src='../assets/css/item-list.css'>
</style>
<style scoped>
.group-data-loader {
  display: block;
  width: 1em;
  height: auto;
  /* height: 2em; */
  margin-left: auto;
  margin-right: auto;
}
.group-data-loader > img {
  width: auto;
  height: 1em;
}
.form-container {
  margin-top: 10svh;
}
.main-page-link {
  margin-top: 2.5rem;
  color: var(--textColorDisabled);
  margin-left: auto;
  margin-right: auto;
  display: table;
  margin-bottom: 1rem;
}
@media screen and (orientation:landscape)
and (min-device-height: 319px) 
and (max-device-height: 480px) {
  .form-container {
    margin-top: 0;
  }
}
</style>